import { render } from "./HeroBlock.vue?vue&type=template&id=6d0f96ba&scoped=true"
import script from "./HeroBlock.vue?vue&type=script&lang=js"
export * from "./HeroBlock.vue?vue&type=script&lang=js"

import "./HeroBlock.vue?vue&type=style&index=0&id=6d0f96ba&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d0f96ba"]])

export default __exports__